import {
  GET_CASHBOOK_PARTY_HEADS,
  GET_CASHBOOK_PARTY_HEADS_SUCCESS,
  SAVE_CASHBOOK_PARTY_HEAD,
  SAVE_CASHBOOK_PARTY_HEAD_SUCCESS,
  CASHBOOK_ENTRY_API_ERROR_ACTION,
  GET_CASHBOOK_ENTRY_LIST,
  GET_CASHBOOK_ENTRY_LIST_SUCCESS,
  EDIT_CASHBOOK_ENTRY_ID,
  EDIT_CASHBOOK_ENTRY_ID_SUCCESS,
  UPDATE_CASHBOOK_ENTRY_ID,
  UPDATE_CASHBOOK_ENTRY_ID_SUCCESS,
  DELETE_CASHBOOK_ENTRY_ID,
  DELETE_CASHBOOK_ENTRY_ID_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  partyHeadList: [],
  postMsg: { Status: false },
  saveBtnloading: false,
  headListLoading: false,
  CashBookEntryListData: [],
  goBtnLoading: false,
  listBtnLoading: false,
  editData: { Status: false },
  updateMessage: { Status: false },
  deleteMessage: { Status: false },
}

const CashBookEntryReducer = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_CASHBOOK_PARTY_HEADS:
      return {
        ...state,
        headListLoading: true,
      }

    case GET_CASHBOOK_PARTY_HEADS_SUCCESS:
      return {
        ...state,
        partyHeadList: action.payload,
        headListLoading: false,
      }

    case SAVE_CASHBOOK_PARTY_HEAD:
      return {
        ...state,
        saveBtnloading: true,
      }

    case SAVE_CASHBOOK_PARTY_HEAD_SUCCESS:
      return {
        ...state,
        postMsg: action.payload,
        saveBtnloading: false,
      }

    case CASHBOOK_ENTRY_API_ERROR_ACTION:
      return {
        ...state,
        saveBtnloading: false,
        headListLoading: false,
        goBtnLoading: false,
        listBtnLoading: false,
      }

    case GET_CASHBOOK_ENTRY_LIST:
      return {
        ...state,
        goBtnLoading: true,
      }

    case GET_CASHBOOK_ENTRY_LIST_SUCCESS:
      return {
        ...state,
        CashBookEntryListData: action.payload,
        goBtnLoading: false,
      }

    case EDIT_CASHBOOK_ENTRY_ID:
      return { ...state, listBtnLoading: action.config.btnId }   // CommonPurchaseList compares this to the button id

    case EDIT_CASHBOOK_ENTRY_ID_SUCCESS:
      return { ...state, editData: action.payload, listBtnLoading: false }

    case UPDATE_CASHBOOK_ENTRY_ID:
      return { ...state, saveBtnloading: true }

    case UPDATE_CASHBOOK_ENTRY_ID_SUCCESS:
      return { ...state, updateMessage: action.payload, saveBtnloading: false }

    case DELETE_CASHBOOK_ENTRY_ID:
      return {
        ...state,
        listBtnLoading: action.config.btnId || true,
      };

    case DELETE_CASHBOOK_ENTRY_ID_SUCCESS:
      return {
        ...state,
        deleteMessage: action.payload,
        listBtnLoading: false,
      };


    default:
      return state
  }
}

export default CashBookEntryReducer